export default __webpack_public_path__ + "static/media/标题-成员@2x的副本.f3df38ec.png";